/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.53.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ForbiddenErrorResponse,
  GetReferenceTablesParams,
  Id,
  InitializeReferenceTable,
  InitializeReferenceTable201,
  ReferenceTable,
  SetReferenceTableDescription,
  SetReferenceTableName,
  UnauthorizedErrorResponse,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

/**
 * Fetch reference tables for a particular tenant.
 * @summary Get reference tables
 */
export const getReferenceTables = (
  tenantId: Id,
  params: GetReferenceTablesParams,
  signal?: AbortSignal
) => {
  return httpClient<ReferenceTable[]>({
    url: `/query-service/tenant/${tenantId}/reference-table-information/get-reference-tables`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetReferenceTablesQueryKey = (
  tenantId?: Id,
  params?: GetReferenceTablesParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "reference-table-information",
    "get-reference-tables",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReferenceTablesQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferenceTables>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetReferenceTablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTables>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReferenceTablesQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReferenceTables>>
  > = ({ signal }) => getReferenceTables(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferenceTables>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReferenceTablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReferenceTables>>
>;
export type GetReferenceTablesQueryError =
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export function useGetReferenceTables<
  TData = Awaited<ReturnType<typeof getReferenceTables>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetReferenceTablesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTables>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceTables>>,
          TError,
          Awaited<ReturnType<typeof getReferenceTables>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReferenceTables<
  TData = Awaited<ReturnType<typeof getReferenceTables>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetReferenceTablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTables>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceTables>>,
          TError,
          Awaited<ReturnType<typeof getReferenceTables>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReferenceTables<
  TData = Awaited<ReturnType<typeof getReferenceTables>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetReferenceTablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTables>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get reference tables
 */

export function useGetReferenceTables<
  TData = Awaited<ReturnType<typeof getReferenceTables>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse
>(
  tenantId: Id,
  params: GetReferenceTablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTables>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReferenceTablesQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const initializeReferenceTable = (
  referenceTableId: Id,
  initializeReferenceTable: InitializeReferenceTable,
  signal?: AbortSignal
) => {
  return httpClient<InitializeReferenceTable201 | void>({
    url: `/command-service/reference-table/aggregate/reference-table/${referenceTableId}/initialize-reference-table`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: initializeReferenceTable,
    signal,
  });
};

export const getInitializeReferenceTableMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof initializeReferenceTable>>,
    TError,
    { referenceTableId: Id; data: InitializeReferenceTable },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof initializeReferenceTable>>,
  TError,
  { referenceTableId: Id; data: InitializeReferenceTable },
  TContext
> => {
  const mutationKey = ["initializeReferenceTable"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof initializeReferenceTable>>,
    { referenceTableId: Id; data: InitializeReferenceTable }
  > = (props) => {
    const { referenceTableId, data } = props ?? {};

    return initializeReferenceTable(referenceTableId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InitializeReferenceTableMutationResult = NonNullable<
  Awaited<ReturnType<typeof initializeReferenceTable>>
>;
export type InitializeReferenceTableMutationBody = InitializeReferenceTable;
export type InitializeReferenceTableMutationError =
  void | UnauthorizedErrorResponse;

export const useInitializeReferenceTable = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof initializeReferenceTable>>,
      TError,
      { referenceTableId: Id; data: InitializeReferenceTable },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof initializeReferenceTable>>,
  TError,
  { referenceTableId: Id; data: InitializeReferenceTable },
  TContext
> => {
  const mutationOptions = getInitializeReferenceTableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const setReferenceTableName = (
  referenceTableId: Id,
  setReferenceTableName: SetReferenceTableName,
  signal?: AbortSignal
) => {
  return httpClient<ReferenceTable>({
    url: `/command-service/reference-table/aggregate/reference-table/${referenceTableId}/set-reference-table-name`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setReferenceTableName,
    signal,
  });
};

export const getSetReferenceTableNameMutationOptions = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setReferenceTableName>>,
    TError,
    { referenceTableId: Id; data: SetReferenceTableName },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setReferenceTableName>>,
  TError,
  { referenceTableId: Id; data: SetReferenceTableName },
  TContext
> => {
  const mutationKey = ["setReferenceTableName"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setReferenceTableName>>,
    { referenceTableId: Id; data: SetReferenceTableName }
  > = (props) => {
    const { referenceTableId, data } = props ?? {};

    return setReferenceTableName(referenceTableId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetReferenceTableNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof setReferenceTableName>>
>;
export type SetReferenceTableNameMutationBody = SetReferenceTableName;
export type SetReferenceTableNameMutationError = UnauthorizedErrorResponse;

export const useSetReferenceTableName = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setReferenceTableName>>,
      TError,
      { referenceTableId: Id; data: SetReferenceTableName },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setReferenceTableName>>,
  TError,
  { referenceTableId: Id; data: SetReferenceTableName },
  TContext
> => {
  const mutationOptions = getSetReferenceTableNameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const setReferenceTableDescription = (
  referenceTableId: Id,
  setReferenceTableDescription: SetReferenceTableDescription,
  signal?: AbortSignal
) => {
  return httpClient<ReferenceTable>({
    url: `/command-service/reference-table/aggregate/reference-table/${referenceTableId}/set-reference-table-description`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setReferenceTableDescription,
    signal,
  });
};

export const getSetReferenceTableDescriptionMutationOptions = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setReferenceTableDescription>>,
    TError,
    { referenceTableId: Id; data: SetReferenceTableDescription },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setReferenceTableDescription>>,
  TError,
  { referenceTableId: Id; data: SetReferenceTableDescription },
  TContext
> => {
  const mutationKey = ["setReferenceTableDescription"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setReferenceTableDescription>>,
    { referenceTableId: Id; data: SetReferenceTableDescription }
  > = (props) => {
    const { referenceTableId, data } = props ?? {};

    return setReferenceTableDescription(referenceTableId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetReferenceTableDescriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof setReferenceTableDescription>>
>;
export type SetReferenceTableDescriptionMutationBody =
  SetReferenceTableDescription;
export type SetReferenceTableDescriptionMutationError =
  UnauthorizedErrorResponse;

export const useSetReferenceTableDescription = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setReferenceTableDescription>>,
      TError,
      { referenceTableId: Id; data: SetReferenceTableDescription },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setReferenceTableDescription>>,
  TError,
  { referenceTableId: Id; data: SetReferenceTableDescription },
  TContext
> => {
  const mutationOptions =
    getSetReferenceTableDescriptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteReferenceTable = (
  referenceTableId: Id,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/reference-table/aggregate/reference-table/${referenceTableId}/delete-reference-table`,
    method: "POST",
    signal,
  });
};

export const getDeleteReferenceTableMutationOptions = <
  TError = UnauthorizedErrorResponse | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReferenceTable>>,
    TError,
    { referenceTableId: Id },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReferenceTable>>,
  TError,
  { referenceTableId: Id },
  TContext
> => {
  const mutationKey = ["deleteReferenceTable"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReferenceTable>>,
    { referenceTableId: Id }
  > = (props) => {
    const { referenceTableId } = props ?? {};

    return deleteReferenceTable(referenceTableId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReferenceTableMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReferenceTable>>
>;

export type DeleteReferenceTableMutationError =
  UnauthorizedErrorResponse | void;

export const useDeleteReferenceTable = <
  TError = UnauthorizedErrorResponse | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReferenceTable>>,
      TError,
      { referenceTableId: Id },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReferenceTable>>,
  TError,
  { referenceTableId: Id },
  TContext
> => {
  const mutationOptions = getDeleteReferenceTableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
